import { Path } from "react-hook-form";
import { IListAdmin } from "../../_api";

export const TAB_FIELDS: Record<number, Path<IListAdmin>[]> = {
  0: ["company_name", "naics_code", "listadmin_type"],
  1: ["address1", "city", "state", "postal_code"],
  2: ["representative_name", "representative_email", "phone"],
  3: [],
};
